module.exports = __webpack_public_path__ + "static/img/anxun32.b67fc0ef.png";